import { ApiProvider } from 'providers/request'
import { ContactParams } from 'models/contact'

export const ContactRepository = {
  contact(data: ContactParams): Promise<void> {
    return ApiProvider.post(`/contact`, data)
  },
}
